/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/view'
export default icon
